import PropTypes from 'prop-types';
import React from 'react';
import ResourceProperty from '../../../../common/resource/ResourceProperty';
import { tzNormalizeDate } from '../../../../../utils/date';
import { DATE_FORMAT } from '../../../../../config/locale';

const HolidayBasicResource = ({ id, holidayDate, name, description }) => (
  <>
    <ResourceProperty label="Id:">{id}</ResourceProperty>
    <ResourceProperty label="Fecha:">
      {tzNormalizeDate({ date: holidayDate, format: DATE_FORMAT })}
    </ResourceProperty>
    <ResourceProperty label="Nombre:">{name}</ResourceProperty>
    <ResourceProperty label="Descripción:">{description}</ResourceProperty>
  </>
);

HolidayBasicResource.propTypes = {
  id: PropTypes.number.isRequired,
  holidayDate: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
};

HolidayBasicResource.defaultProps = {
  description: '',
};

export default HolidayBasicResource;